import React from "react";
import { useEffect, useMemo, useState } from "react";
import useReduxData from "../../hooks/useReduxData";
import useAppDispatch from "../../hooks/useAppDispatch";
import { SETSEARCH } from "../../redux/features/FilterData";
import FilterItem from "../../utils/FilterItem";
const placeholderItem = [
  "Pizza",
  "Shakes",
  "Thali",
  "Beverages",
  "Pasta",
  "Burger",
  "Soup",
];
import useSearchItem from "../../hooks/useSearchItem";
function MobileHeaderSearch({ updateShowMobileSearch }: any) {
  const {
    filterData: { search },
  } = useReduxData();
  const { handleSearch } = useSearchItem();
  const [count, setCount] = useState(0);
  const [animatingOut, setAnimatingOut] = useState(false);
  // const [showSearchInput, setShowSearchInput] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimatingOut(true);
      setTimeout(() => {
        setCount((prev) => (prev + 1) % placeholderItem.length);
        setAnimatingOut(false);
      }, 600);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // @@ show search input
  const showSearchInput = useMemo(() => {
    return search ? true : false;
  }, [search]);

  return (
    <div className="mobile-search-bar">
      <div className="fixed right-0 top-0 left-0 bg-white z-50">
        <div className="sticky px-4 py-2">
          <div className="mobile-search-head flex items-center">
            {/* Back Button */}
            <div className="flex w-[10%]">
              <button
                onClick={() => {
                  handleSearch("");
                  updateShowMobileSearch(false);
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <title>Arrow left</title>
                  <path
                    d="M22 13.5H6.3l5.5 7.5H8.3l-6.5-9 6.5-9h3.5l-5.5 7.5H22v3Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Input with animated placeholder */}
            <div className="flex w-[80%] relative">
              <input
                type="text"
                // value={showSearchInput}
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
                className="w-full rounded-lg px-3 py-2 focus:outline-none"
              />

              {/* Custom Placeholder */}
              {!showSearchInput && (
                <div className="absolute left-0 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex">
                  <span>Search for &nbsp;</span>
                  <span
                    className={`transition-all duration-700 ease-in-out ${
                      animatingOut
                        ? "opacity-0 translate-y-1"
                        : "opacity-100 translate-y-0"
                    }`}
                  >
                    &quot;{placeholderItem[count]}&quot;
                  </span>
                </div>
              )}
            </div>

            {/* Clear button */}
            {showSearchInput && (
              <div className="flex w-[10%] items-center justify-center">
                <button
                  onClick={() => {
                    handleSearch("");
                    updateShowMobileSearch(false);
                  }}
                >
                  <svg
                    data-v-256125a6=""
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    height="14"
                    width="14"
                  >
                    <path
                      d="M23.25 23.249L0.75 0.749"
                      fill="none"
                      stroke="#000"
                      stroke-linecap="round"
                      strokeLinejoin="round"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M0.75 23.249L23.25 0.749"
                      fill="none"
                      stroke="#000"
                      stroke-linecap="round"
                      strokeLinejoin="round"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileHeaderSearch;
